module.exports = __webpack_public_path__ + "static/media/bags-oversize.3533c76b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bags-oversize.svg
// module id = 705
// module chunks = 0